module.exports = __webpack_public_path__ + "img/MeetingHub-EmailLogo.cfe5a892.png";